import React from 'react';
import ProspectCustomerDashboard from '../personal-dashboard/prospect-customer/ProspectCustomerDashboard'
const ManagerProspectDashboard = () => {
  return (
    <>
      <ProspectCustomerDashboard isFromManagerPage={true} page={1} size={12} />
    </>
  );
};

ManagerProspectDashboard.propTypes = {};

export default ManagerProspectDashboard;
